import { DSNCAA } from 'types.aa.ds'
import NC from 'nc/NC'
import { PostContext } from 'shared-components/contexts/PostContext'

interface UnderTitleAdsProps {
  ads: readonly DSNCAA[]
}

const UnderTitleAds: React.FC<UnderTitleAdsProps> = ({ ads }) => {
  const { disabledAds } = PostContext.useContainer()
  if (disabledAds || ads.length === 0) {
    return null
  }

  return (
    <div>
      {ads.map((item, index) => (
        <NC key={index} data={item} tpl="post" index={index} />
      ))}
    </div>
  )
}

export default UnderTitleAds
